module.exports = __webpack_public_path__ + "static/media/password_reset.1710e8a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/password_reset.svg
// module id = 111
// module chunks = 0